import { Icon } from '@brighterionai/br-ui';
import clsx from 'clsx';
import React from 'react';
import { AuthService } from 'Services';
import { useAppStore } from 'Store';
import { handleKeyEvent, handleOnClickEvent } from 'Utils';
import styles from './ImpersonationHeader.css';

const ImpersonationHeader: React.FC = () => {
    const user = useAppStore.use.user();
    const { landlordId, tenantKey } = user;

    const backToLandlordView = async () => {
        try {
            if (landlordId) {
                await AuthService.init(landlordId);
                window.location.replace('/tenants');
            }
        } catch (error: any) {
            if (error.response?.status === 401) {
                try {
                    await AuthService.refreshAccessToken();
                    if (landlordId) {
                        await AuthService.init(landlordId);
                        window.location.replace('/tenants');
                    }
                } catch (err) {
                    console.error('Failed to return to landlord view:', err);
                    window.location.reload();
                }
            } else {
                console.error('Error returning to landlord view:', error);
            }
        }
    };

    return (
        <div className={styles.impersonateHeaderContainer}>
            <div className={styles.impersonateHeaderItem}>
                {`${tenantKey} WATCHLIST SCREENING - Logged in as ${landlordId}`}
            </div>
            <div
                className={clsx(styles.impersonateHeaderItem, styles.backButtonWrapper)}
                data-testid='impersonate-header-back-button'
                onClick={handleOnClickEvent(backToLandlordView)}
                onKeyDown={handleKeyEvent(backToLandlordView)}
                role='button'
                tabIndex={0}
            >
                <Icon className={styles.backIcon} name='arrow-left-1' size='sm' />
                <span>Back to Watchlist management</span>
            </div>
        </div>
    );
};

export default ImpersonationHeader;
